import {SUBSCRIPTION_STORE_NAME} from '../reducers/reducers'

export function getSubscriptionItems(state) {
    const stored = state[SUBSCRIPTION_STORE_NAME] || { }
    return stored.items
}
